// src/layouts/MainLayout.jsx

import React from 'react';
import HamburgerMenu from '../components/Layout/HamburgerMenu';

const MainLayout = ({ children }) => {
    return (
        <div className="min-h-screen bg-gray-100" >
            <HamburgerMenu />
            <main className="pt-4">
                {children}
            </main>
        </div>
    );
};
export default MainLayout;